import React from 'react';
import { Link } from 'react-router-dom';
import { FaUsers, FaClock, FaArrowRight } from 'react-icons/fa';
import IconWrapper from './IconWrapper';
import './ConferenceRoomPreview.css';

const ConferenceRoomPreview: React.FC = () => {
  const features = [
    {
      icon: FaUsers,
      text: 'Up to 67 People'
    },
    {
      icon: FaClock,
      text: 'Hourly Rentals'
    }
  ];

  return (
    <section id="conference-room-preview" className="conference-room-preview">
      <div className="container">
        <div className="conference-preview-content">
          <div className="conference-preview-image">
            <img 
              src="/conference-room/conf1.webp" 
              alt="Professional Conference Room" 
              className="preview-image"
            />
            <div className="image-overlay">
              <span className="capacity-badge">Up to 67 People</span>
            </div>
          </div>
          
          <div className="conference-preview-info">
            <div className="preview-header">
              <h3>Professional Conference Room</h3>
              <p>Bright, fully-equipped space perfect for team meetings, presentations, and corporate events.</p>
            </div>
            
            <div className="preview-features">
              {features.map((feature, index) => (
                <div key={index} className="preview-feature">
                  <div className="preview-feature-icon">
                    <IconWrapper icon={feature.icon} />
                  </div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>
            
            <div className="preview-cta">
              <Link to="/conference-room" className="preview-btn primary">
                Book Now
              </Link>
              <Link to="/conference-room" className="preview-btn secondary">
                View Details
                <span className="arrow-icon">
                  <IconWrapper icon={FaArrowRight} />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConferenceRoomPreview;
